import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';

import { ReadableDatePipe } from './readable-date.pipe';

@NgModule({
    declarations: [ReadableDatePipe],
    imports: [CommonModule],
    providers: [ReadableDatePipe, DatePipe],
    exports: [ReadableDatePipe]
})
export class ReadableDatePipeModule {}

export { ReadableDatePipe };
